import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260910_remove_analytic_snap_entities",
  description: "Remove unsupported analytic geometry snapping settings",
  apply(json: { snapEntities?: string[] }) {
    if (json.snapEntities) {
      json.snapEntities = json.snapEntities.filter((entity: string) => !entity.startsWith("ANALYTIC_"));
    }
    return json;
  },
};

export default migration;
